import { Home, Layers, Package, Settings, Truck } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function IomiDefaultsHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'platform-quote-defaults',
      label: 'Quote Defaults',
      desc: 'Set platform-wide default quote settings applied to every new organization.',
      icon: Settings,
      path: '/admin/platform-tools/platform-quote-defaults',
    },
    {
      id: 'master-inventory',
      label: 'Master Inventory',
      desc: 'Manage the platform-wide inventory catalog used by all organizations.',
      icon: Package,
      path: '/admin/platform-tools/master-inventory',
    },
    {
      id: 'master-services',
      label: 'Master Services',
      desc: 'Manage the platform-wide list of services available for scoping on each job.',
      icon: Layers,
      path: '/admin/platform-tools/master-services',
    },
    {
      id: 'master-residential-defaults',
      label: 'Master Residential Defaults',
      desc: 'Manage rooms and default configurations for residential moving quotes.',
      icon: Home,
      path: '/admin/platform-tools/master-residential-defaults',
    },
    {
      id: 'fleet-defaults',
      label: 'Fleet Defaults',
      desc: 'Manage truck types and make/model catalog for fleet management.',
      icon: Truck,
      path: '/admin/platform-tools/fleet-defaults',
    },
  ];

  return (
    <HubPageLayout
      title="Platform Defaults"
      subtitle="Master inventory, services, and residential config."
      rows={rows}
      backPath="/admin/platform-tools"
      backLabel="Platform Admin Tools"
    />
  );
}
